<div class="maxWidthMaxHeight">
    <router-outlet></router-outlet>
</div>